import PMDA from '../components/PMDA';
import ProductResourcesCuration from '../components/PMDA/ProductResourcesCuration';
import AutoLabelTranslation from '../components/PMDA/AutoLabelTranslation';
import DAGCuration from '../components/PMDA/components/DAGCuration';
import EssentialDataCuration from '../components/PMDA/EssentialDataCuration';
import ReviewReportResourceCuration from '../components/PMDA/ReviewReportResourceCuration';
import ListTranslationQuality from '../components/PMDA/ListTranslationQuality';
import EditTranslationQuality from '../components/PMDA/EditTranslationQuality';

const PMDA_BASE_ROUTE = '/pmda';
const PMDA_ESSENTIAL_DATA_CURATION_ROUTE = '/pmda/essential-data-curation';
const PMDA_PRODUCT_RESOURCES_SECTION_AND_NUMBER_CURATION_ROUTE = '/pmda/:curation_type';

const PMDA_ROUTES = [
  {
    id: 'pmda',
    path: PMDA_BASE_ROUTE,
    component: PMDA,
    exact: true
  },
  {
    id: 'pmdacuration',
    path: `${PMDA_BASE_ROUTE}/curation/check`,
    component: DAGCuration,
    exact: true
  },
  {
    id: 'pmda-package-insert-translation',
    path: `${PMDA_BASE_ROUTE}/translate/package-insert`,
    component: AutoLabelTranslation,
    exact: true
  },
  {
    id: 'pmdaProductResourcesSectionSeparation',
    path: PMDA_PRODUCT_RESOURCES_SECTION_AND_NUMBER_CURATION_ROUTE,
    component: ProductResourcesCuration,
    exact: false
  },
  {
    id: 'pmdaEssentialDataCuration',
    path: PMDA_ESSENTIAL_DATA_CURATION_ROUTE,
    component: EssentialDataCuration,
    exact: false
  },

  {
    id: 'pmdaReviewReportCuration',
    path: `${PMDA_BASE_ROUTE}/review-report-resource-curation`,
    component: ReviewReportResourceCuration,
    exact: true
  },
  {
    id: 'pmdaQualityTranslations',
    path: `${PMDA_BASE_ROUTE}/quality/translations`,
    component: ListTranslationQuality,
    exact: true
  },
  {
    id: 'pmdaQualityTranslationsById',
    path: `${PMDA_BASE_ROUTE}/quality/translation/:yjCode`,
    component: EditTranslationQuality
  }
];

export default PMDA_ROUTES;
